export default __webpack_public_path__ + "static/media/rw.ab1e83ee.svg";